import { Loading } from 'components/loading';
import { UpdateEmployeePersonalDetailsInput } from 'features/employees/api/repositories/use-employee-personal-details-update.mutation';
import { FC, useEffect } from 'react';
import { FieldErrors, FieldNamesMarkedBoolean, UseFormRegister } from 'react-hook-form';

type Props = {
  isLoading: boolean;
  isSubmitting: boolean;
  register: UseFormRegister<UpdateEmployeePersonalDetailsInput>;
  errors: FieldErrors<UpdateEmployeePersonalDetailsInput>;
  touchedFields: Partial<Readonly<FieldNamesMarkedBoolean<UpdateEmployeePersonalDetailsInput>>>;
};

const HealthCareDetails: FC<Props> = ({ isLoading, isSubmitting, register, errors, touchedFields }) => {
  return (
    <div className="card mb-5 mb-xl-10">
      <div
        className="card-header border-0 cursor-pointer"
        role="button"
        data-bs-toggle="collapse"
        data-bs-target="#kt_employee_health-care-details"
        aria-expanded="true"
        aria-controls="kt_employee_health-care-details"
      >
        <div className="card-title m-0">
          <h3 className="fw-bolder m-0">Health Care Details</h3>
        </div>
      </div>

      <div id="kt_from_employee_health-care-details" className="collapse show">
        <div className="card-body border-top p-9">
          <div className="row mb-6">
            <div className="col-lg-6 fv-row">
              <label className="col-lg-4 col-form-label fs-6">Name of Doctor</label>
              <input
                type="text"
                disabled={isSubmitting || isLoading}
                className="form-control form-control-lg form-control-solid"
                placeholder="Doctor name"
                {...register('input.requestBody.doctorName')}
              />
              {touchedFields.input?.requestBody?.doctorName && errors.input?.requestBody?.doctorName && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{errors.input.requestBody.doctorName?.message}</div>
                </div>
              )}
            </div>
            <div className="col-lg-6 fv-row">
              <label className="col-lg-4 col-form-label fs-6">Doctor&apos;s tel No</label>
              <input
                type="number"
                disabled={isSubmitting || isLoading}
                className="form-control form-control-lg form-control-solid"
                placeholder="Doctor tel number"
                {...register('input.requestBody.doctorTelNo')}
              />
              {touchedFields.input?.requestBody?.doctorTelNo && errors.input?.requestBody?.doctorTelNo && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{errors.input.requestBody.doctorTelNo?.message}</div>
                </div>
              )}
            </div>
          </div>

          <div className="row mb-6">
            <div className="col-lg-6 fv-row">
              <label className="col-lg-4 col-form-label fs-6">Address</label>
              <input
                type="text"
                disabled={isSubmitting || isLoading}
                className="form-control form-control-lg form-control-solid"
                placeholder="Doctor address"
                {...register('input.requestBody.doctorAddress')}
              />
              {touchedFields.input?.requestBody?.doctorAddress && errors.input?.requestBody?.doctorAddress && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{errors.input?.requestBody.doctorAddress?.message}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loading />}
    </div>
  );
};

export { HealthCareDetails };
